<template>
  <div class="c-stick">
    <div class="c-col-field">{{ description }}</div>
    <div class="c-stick-wrap">
      <!-- 封面贴纸 -->
      <Dropdown placement="right-end">
        <img v-if="url" :src="url" width="40" />
        <el-button type="text" v-else class="c-defaut-text">
          请选择贴纸样式
          <Icon type="ios-arrow-down"></Icon>
        </el-button>
        <DropdownMenu slot="list">
          <Dropdown v-for="(item, id) in enumeration" :key="id" placement="right-start">
            <DropdownItem>
              贴纸样式{{ id + 1 }}
              <Icon type="ios-arrow-forward"></Icon>
            </DropdownItem>
            <el-radio-group v-model="stick" slot="list" class="c-dropdown-child">
              <el-radio v-for="slog of item.sticker_styles" :key="slog.overlay_type" :label="slog.overlay_type">
                <img :src="slog.overlay_preview_url" alt="" width="50" />
              </el-radio>
            </el-radio-group>
          </Dropdown>
        </DropdownMenu>
      </Dropdown>
      <a v-if="stick" href="javascript:;" class="c-clear" @click="$emit('input', '')"> 清除 </a>
    </div>
    <div v-if="msg" class="c-col-msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixinVerify from './mixin-verify'
export default {
  name: 'creatStick',
  mixins: [mixinVerify],
  props: {
    value: {
      type: String
    },
    description: {
      type: String,
      default: ''
    },
    enumeration: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    verify: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    stick: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    drops() {
      return this.enumeration.map((ret) => ret.sticker_styles).flat()
    },
    url() {
      if (this.value) {
        const overlay = this.drops.filter((ret) => ret.overlay_type === this.value).pop()
        if (overlay) return overlay.overlay_preview_url
        else return ''
      } else return ''
    }
  }
}
</script>
<style lang='scss' scoped>
.c-stick {
  width: 100%;
  position: relative;
  z-index: 5;
  display: flex;

  .c-col-field {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 120px;
    line-height: 32px;
    text-align: right;
    padding-right: 12px;
  }

  .c-clear {
    padding-left: 8px;
    color: #ff4400;
  }

  .ivu-dropdown-menu {
    max-width: 108px;
  }

  ::v-deep .ivu-select-dropdown {
    width: auto !important;
  }

  .ant-radio-group {
    display: flex;

    .ant-radio-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 0;

      img {
        margin-top: 4px;
      }
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 4;
    left: 120px;
    bottom: -4px;
    color: #ff4400;
  }
}
</style>
